export function frame(element) {
    element.classList.add('framed');
}

export function pad(element, padding) {
    element.style.padding = '1em';
}